
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/create",
      function () {
        return require("private-next-pages/account/create.js");
      }
    ]);
  